


















































import { Component, Vue, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { Spinner } from 'vue-image-spinner2';
import { mapState } from 'vuex';

@Component({
    name: 'email-feedback-modal',
    components: {
        Spinner,
    },
    computed: {
        ...mapState('feedbackInvoices', ['activeFeedbackInvoice', 'activeFeedbackInvoiceLoading']),
    },
})
export default class EmailFeedbackModal extends Vue {
    public recipients: any[] = [
        {
            email: 'alejandro.montufar@prodelec.mx',
            isDefault: true,
            role: 'prodelec'
        },
    ];

    public newEmail: string = '';
    public activeFeedbackInvoice!: any;
    public activeFeedbackInvoiceLoading!: any;

    public addEmail() {
        if (this.newEmail && this.validateEmail(this.newEmail)) {
            const exists = this.recipients.some((email) => email.email === this.newEmail);
            if (!exists) {
                this.recipients.push({ email: this.newEmail, isDefault: false, role: 'extra'});
                this.newEmail = '';
            } else {
                this.$bvToast.toast('El correo eletrónico ya se ingresó.', {
                    title: `Correo existente`,
                    variant: 'warning',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
            }
        } else {
            this.$bvToast.toast('Por favor, ingresa un correo válido.', {
                title: `Correo inválido`,
                variant: 'warning',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        }
    }

    public removeEmail(index: number) {
        if (!this.recipients[index].isDefault) {
            this.recipients.splice(index, 1);
        }
    }
    private validateEmail(email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    public sendEmails() {
        this.$bvModal.hide('email-feedback-modal');
        this.$store.dispatch('feedbackInvoices/sendInvoice', { emails: this.recipients, id: this.activeFeedbackInvoice.id, view: this });
    }

    @Watch('activeFeedbackInvoice')
    onActiveFeedbackInvoiceChange(newValue: any) {
        if (newValue?.invoice_data?.email) {
            const exists = this.recipients.some((recipient) => recipient.email === newValue.invoice_data.email);

            if (!exists) {
                this.recipients.push({
                    email: newValue.invoice_data.email,
                    isDefault: true,
                    role:'client'
                });
            }
        }
    }
}
